import { useEffect, useState } from 'react'
import { canUseAgenticSourcing } from '../../lib/sourcing'

/**
 * Reactive `canUseAgenticSourcing()` — re-reads on the boot hydration
 * broadcast (`aska:sourcing-changed`) so a flag that arms mid-session reveals
 * the RFQ entry points / Profile tiles without a reload. One hook so every
 * surface subscribes the same way (the twin of WantListPanel's local
 * `useRfqLive`, promoted so tiles + entry points can share it).
 */
export function useAgenticSourcing(): boolean {
  const [on, setOn] = useState<boolean>(() => canUseAgenticSourcing())
  useEffect(() => {
    const onChange = () => setOn(canUseAgenticSourcing())
    window.addEventListener('aska:sourcing-changed', onChange)
    return () => window.removeEventListener('aska:sourcing-changed', onChange)
  }, [])
  return on
}
